import { ICreateSendRecipient } from '../../types/createSendRecipients';
import { ICommonAddress } from '../../types/shipping';

const isString = (value: unknown): value is string => typeof value === 'string';

const isOptionalString = (value: unknown): value is string | undefined => value === undefined || isString(value);

const isPersistedAddress = (value: unknown): value is ICommonAddress | null | undefined =>
  value === undefined || value === null || (typeof value === 'object' && !Array.isArray(value));

export const isPersistableRecipient = (value: unknown): value is ICreateSendRecipient => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false;
  }

  const candidate = value as Partial<ICreateSendRecipient>;

  return (
    isString(candidate.uid) &&
    candidate.uid.length > 0 &&
    isString(candidate.first_name) &&
    isString(candidate.last_name) &&
    isString(candidate.email) &&
    isOptionalString(candidate.phone) &&
    isOptionalString(candidate.tax_number) &&
    isOptionalString(candidate.savedAddressId) &&
    isPersistedAddress(candidate.address)
  );
};

export const pickPersistedRecipient = (recipient: ICreateSendRecipient): ICreateSendRecipient => ({
  uid: recipient.uid,
  first_name: recipient.first_name,
  last_name: recipient.last_name,
  email: recipient.email,
  address: recipient.address ?? null,
  ...(recipient.phone === undefined ? {} : { phone: recipient.phone }),
  ...(recipient.tax_number === undefined ? {} : { tax_number: recipient.tax_number }),
  ...(recipient.savedAddressId === undefined ? {} : { savedAddressId: recipient.savedAddressId }),
});

export const normalizePersistedRecipients = (value: unknown): ICreateSendRecipient[] =>
  Array.isArray(value) ? value.filter(isPersistableRecipient).map(pickPersistedRecipient) : [];
